import { ArrowLeft } from "@credcore/core-ui/icons";
import { Link } from "react-router-dom";
import { IngestionForm } from "./IngestionForm";
import { ClassificationForm } from "./ClassificationForm";

export function Settings() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link
          to="/"
          className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Dashboard
        </Link>
      </div>

      <div>
        <h2 className="text-2xl font-bold text-gray-900">Admin Settings</h2>
        <p className="mt-1 text-sm text-gray-500">
          Run data ingestion and classification tasks
        </p>
      </div>

      <div className="grid items-stretch gap-6 lg:grid-cols-2">
        <IngestionForm />
        <ClassificationForm />
      </div>
    </div>
  );
}
